import { environment } from "./environment";

export class AppConfig {
    public static salarioMinimo(): number { return Number(`${environment.MINIMUN_SALARY}`); }


    public static salarioMaximoSap(): number { return Number(`${environment.SALARIO_MAXIMO_SAP}`);
    }

}